// @flow
import React from 'react';
import Rating from 'react-rating';
import { makeStyles } from '@material-ui/core/styles';

import RatingStarIcon from '../Icons/RatingStar';

const useStyles = makeStyles(theme => ({
  star: {
    marginRight: 8,
  },
}));

interface Props {
  initialRating?: number | typeof undefined;
  onChange: (value: number) => void;
  onHover: (value: number) => void;
  rating: number;
  readonly: boolean;
}

const RatingSelector = ({ initialRating, onChange, onHover, readonly, rating }: Props) => {
  const classes = useStyles();

  let starColor = '';
  if (!rating) {
    starColor = '#150ACEF';
  } else if (rating <= 2) {
    starColor = '#DE423E';
  } else if (rating !== 3) {
    starColor = '#05BF6F';
  } else {
    starColor = '#ED8822';
  }

  return (
    <Rating
      emptySymbol={
        <div className={classes.star}>
          <RatingStarIcon />
        </div>
      }
      fullSymbol={
        <div className={classes.star}>
          <RatingStarIcon fill={starColor} />
        </div>
      }
      readonly={readonly}
      initialRating={initialRating}
      onChange={onChange}
      onHover={onHover}
    />
  );
};

export default RatingSelector;
